import { Reveal, SectionHeading } from "./Reveal";

const STATS = [
  { title: "Strategy-led", label: "Structure shaped around your business and customers." },
  { title: "Mobile-first", label: "A polished experience across every screen size." },
  { title: "Clear stages", label: "Defined steps from discovery through to launch." },
  { title: "Launch support", label: "Practical help connecting and publishing your website." },
];

const About = () => (
  <section id="about" data-testid="about-section" className="relative z-10 py-28 sm:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-10">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20 items-start">
        <div>
          <SectionHeading
            kicker="About CLOSER."
            title="We Build Digital Experiences That Move Businesses Forward."
            testId="about-heading"
          />
          <Reveal i={3}>
            <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-white/55">
              CLOSER. is a UK-based premium web design and development studio built around one belief —
              your website should be your hardest-working asset. We don't do templates, page builders
              or cookie-cutter themes. Every project is designed from a blank canvas, engineered for
              speed, and polished until it feels effortless.
            </p>
          </Reveal>
          <Reveal i={4}>
            <p className="mt-6 text-base md:text-lg font-light leading-relaxed text-white/55">
              From cinematic 3D environments to conversion-focused layouts, everything we build exists
              to make your business{" "}
              <span className="font-serif-accent text-white/85 text-lg md:text-xl">stand out online</span> —
              and to turn visitors into enquiries, bookings and sales.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 gap-5">
          {STATS.map((s, i) => (
            <Reveal key={s.label} i={i}>
              <div
                data-testid={`about-stat-${i}`}
                className="rounded-3xl glass p-8 transition-[background-color,border-color] duration-500 hover:bg-white/[0.06] hover:border-white/25"
              >
                <span className="font-display text-2xl sm:text-3xl font-bold tracking-tight chrome-text">
                  {s.title}
                </span>
                <p className="mt-4 text-[13px] font-light tracking-wide text-white/50">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
